import React, { ReactNode } from "react";

interface EditorLayoutProps {
  leftSidebar: ReactNode;
  rightSidebar: ReactNode;
  children: ReactNode; // Center Workspace
  rightSidebarClass?: string;
}

const EditorLayout: React.FC<EditorLayoutProps> = ({
  leftSidebar,
  rightSidebar,
  children,
  rightSidebarClass = "",
}) => {
  return (
    <div className="main_container">
      {/* Dynamic Left Sidebar */}
      <div className="editor_left_sidebar">{leftSidebar}</div>

      {/* Common Center Workspace */}
      <div className="editor_center_workspace">{children}</div>

      {/* Dynamic Right Sidebar */}
      <div className={`editor_right_sidebar ${rightSidebarClass}`.trim()}>
        {rightSidebar}
      </div>
    </div>
  );
};

export default EditorLayout;
